// Webpack Imports
import * as bootstrap from 'bootstrap';


(function ($) {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	$(document).on('ready', function () {
		if ($('.fx-hero').length) {
			$('.fx-hero').prepend('<div class="fx"></div>')

			$(window).on('scroll', function () {
				$('.fx-hero .fx').css({ top: $(window).scrollTop() * 0.2 })
				$('.fx-hero .fx').css({ bottom: -$(window).scrollTop() * 0.2 })
			})
		}

		if ($('.fx-diamond').length) {
			$('.fx-diamond').prepend('<img class="fx" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI3OTIiIHZpZXdCb3g9IjAgMCAxNDQwIDc5MiIgZmlsbD0ibm9uZSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNjBMNzIwIDBMMTQ0MCA2MFY2NzJMNzIxIDc5MkwwIDY3MlY2MFoiIGZpbGw9IiMwQTIyNDAiLz4KPC9zdmc+Cg=="/>');
		}
		if ($('.fx-white').length) {
			$('.fx-white').prepend('<img class="fx" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI4NTIiIHZpZXdCb3g9IjAgMCAxNDQwIDg1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNjBMNzIwIDBMMTQ0MCA2MFY3MzJMNzIxIDg1MkwwIDczMlY2MFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="/>');
		}


		if ($('.acordeon').length) {
			$('.acordeon').each(function () {
				$(this).find('.closed .content').css({ display: 'none' });
			});

			$('.acordeon .title, .acordeon .icon').on('click', function () {
				const $acordeon = $(this).closest('.acordeon');
				const $item = $(this).closest('.closed');
				const index = $item.index();

				if ($item.length) {
					$acordeon.find('.opened').removeClass('opened').addClass('closed').find('.content').slideUp();
					$item.removeClass('closed').addClass('opened').find('.content').slideDown();

					$acordeon.find('.images > div').removeClass('opened').addClass('closed');
					$acordeon.find('.images > div:eq(' + index + ')').removeClass('closed').addClass('opened');
				}
			});
		}

		$('.icon-close').on('click', function () {
			$('#navbar').addClass('fadeout');
			$('#navbar').removeClass('show');
		});
		$('#navbar').on('show.bs.collapse', function () {
			$('#navbar').removeClass('fadeout');
		});

		$('input[type="checkbox"]').after("<span class='fake-check'></span>");

		$(document).on('click', '.modal .close', function () {
			$(this).closest('.modal').modal('hide');
		});

		$('#request').modal({
			backdrop: false
		});

		$('.modal .modal-backdrop').on('click', function () {
			$(this).closest('.modal').modal('hide');
		});


		$(document).on('click', '[href="#request"]', function () {
			$('#request').modal('show');
			return false;
		});


		$("select").on("selectmenucreate", function (event, ui) {
			if ($(this).val()) {
				$(this).selectmenu("widget").addClass('hasValue');
			}
		});
		$("select").on("selectmenuchange", function (event, ui) {
			if ($(this).val()) {
				$(this).selectmenu("widget").addClass('hasValue');
			} else {
				$(this).selectmenu("widget").removeClass('hasValue');
			}
		});
		$("select").on("selectmenuopen", function (event, ui) {
			var id = $(this).selectmenu("widget").attr('aria-activedescendant');
			$('.ui-menu-item-wrapper').removeClass('actived');
			$('#' + id).addClass('actived');
		});

		$('select').selectmenu()
			.selectmenu("menuWidget")
			.addClass("overflow");
	});

})(jQuery);